import { GravyBinder } from "gravy-bind";
import reportValidity from 'report-validity';
import Inputmask, { Instance } from "inputmask/dist/inputmask";
import { IErrorValidator } from "./error-validator.interface";
import { formHasValue } from "./utils/form-has-value";
import { touchAllInputs } from "./utils/touch-all-inputs";

declare var window: any;

export class ClaimsSatisfaction implements IErrorValidator {
    public static htmlId = 'claims-satisfaction-survey';

    controls: Record<string, any> = {};
    binder: GravyBinder;
    rootElement: HTMLFormElement;
    submitAttempted = false;
    public contactChoice: string;
    public get desiresContact(): boolean {
        return this.contactChoice == 'True';
    }
    public recaptcha: string;
    private phoneMask: Instance = Inputmask('999-999-9999');

    constructor(rootElement: HTMLElement) {
        this.rootElement = rootElement as HTMLFormElement;
        this.initialize();
    }

    public initialize = (): void => {
        this.binder = new GravyBinder(this, this.rootElement);
        this.binder.updateBindings();
        this.rootElement.addEventListener('submit', this.onSubmit);
        this.phoneMask.mask(this.rootElement.getElementsByClassName('phone-input')[0] as HTMLInputElement);
        this.rootElement.querySelector('.thumb-up').addEventListener('click', this.changeColor);
        this.rootElement.querySelector('.thumb-down').addEventListener('click', this.changeColor);


    }

    public highlightError = (formInputName: string): boolean => {
        if (!this.submitAttempted)
            return false;
        return formHasValue(this.rootElement, formInputName);
    }

    private onSubmit = (event: Event): void => {
        event.preventDefault();
        this.submitAttempted = true;
        this.binder.updateOutwardBindings();
        touchAllInputs(this.rootElement);
        reportValidity(this.rootElement); // using polyfill instead of form.reportValidity for IE support

        if (this.rootElement.checkValidity() && this.recaptcha) {
            this.rootElement.submit();
        }
    }

    private changeColor = (event: Event): void => {
        let target = event.target as HTMLElement;
        let thumbUp = this.rootElement.querySelector('.thumb-up') as HTMLElement; 
        let thumbDown = this.rootElement.querySelector('.thumb-down') as HTMLElement;
        let stronglyAgreeInput = document.getElementsByName("StronglyAgree")[0] as HTMLInputElement;

        if (target && target.className.includes("thumb-up")) {
            stronglyAgreeInput.value = "true";
            thumbUp.style.background = "green";
            thumbUp.style.color = "white";
            thumbDown.style.background = "white";
            thumbDown.style.color = "black";
        } else if (target && target.className.includes("thumb-down")) {
            stronglyAgreeInput.value = "false";
            thumbUp.style.background = "white";
            thumbUp.style.color = "black";
            thumbDown.style.color = "white";
            thumbDown.style.background = "red";
        }
    }
}
